<template>
  <!-- Modal -->
  <div class="modal fade" ref="vuemodal" id="ArchiveStockMoveModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content" style="width: 1000px">
        <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{ translations('inventory.inventory_movement') }}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <h5 v-if="stock">{{ translations('inventory.shipping') }}：{{stock.jan_code}} {{stock.type_number}}</h5>
          <table class="table table-striped table-align-middle">
            <thead>
              <tr>
                <th>{{ translations('inventory.moving_source') }}</th>
                <th>{{ translations('inventory.number_stock_to_move_from') }}</th>
                <th>{{ translations('inventory.destination') }}</th>
                <th>{{ translations('inventory.quantity') }}</th>
                <th>{{ translations('inventory.condition') }}</th>
                <th>{{ translations('inventory.moving_date') }}</th>
              </tr>
            </thead>
            <tbody class="nowrap">
              <tr>
                <td>
                  <select class="custom-select" v-model="from_warehouse_id" @change="getNewQuantity">
                    <option v-for='(warehouse, i) in warehouses' :value="warehouse.id" :key='`from-${i}`'>{{ warehouse.name }}</option>
                  </select>
                </td>
                <td v-if="stock">{{stock.amount}}</td>
                <td>
                  <select class="custom-select" v-model="to_warehouse_id">
                    <option value="0">-</option>
                    <option v-for='(warehouse, i) in warehouses' :value="warehouse.id" :key='`to-${i}`'>{{ warehouse.name }}</option>
                  </select>
                </td>
                <td><input placeholder="0" v-model="amount" min="0" class="form-control input-amount"></td>
                <td>
                  <select class="custom-select" v-model="to_condition_id">
                   <option value="0">-</option>
                   <option v-for='(to_condition, i) in to_conditions' :value="to_condition.id" :key='`to-${i}`' >{{ to_condition.name }}</option>
                  </select>
                </td>
                <td>
                  <div class="d-flex">
                    <input
                      v-model="referenceAt"
                      type="date"
                      class="form-control input-date"
                      @change="getNewQuantity"
                    >
                    <input
                      v-model="timeReferenceAt"
                      type="time"
                      class="form-control input-time"
                      @blur="getNewQuantity"
                    >
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div>{{ translations('inventory.message_notification_set_time') }}</div>
          <div v-show="isValidAmount" class="text-danger">{{ translations('inventory.message_notification_number_stock_moved') }}</div>
          <div v-show="Number(amount) < 0" class="text-danger">{{ translations('inventory.message_notification_enter_number') }}</div>
        </div>
        <div class="modal-footer">
          <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{ translations('common.close') }}</button>
          <button type="button" class="btn btn-primary" @click="moveWarehouse()" :disabled="Number(amount) <= 0 || isValidAmount">{{ translations('common.update') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { format } from 'date-fns'
import { mapState } from 'vuex'

export default {
  name: 'ArchiveStockMoveModal',
  components: {
    VueElementLoading
  },
  props: {
    warehouses: null,
    currentStock: null,
    product: null,
    condition: null,
    date: null
  },
  watch: {
    currentStock (val) {
      this.stock = { ...val }
    }
  },
  data () {
    return {
      stock: { ...this.currentStock },
      from_warehouse_id: 0,
      to_warehouse_id: 0,
      amount: 0,
      amount_max: 0,
      in_stock_status: 0,
      isSearching: false,
      referenceAt: this.$invoiceTools.getCurrentDate(),
      timeReferenceAt: '',
      to_condition_id: 0,
      selected: '',
      to_conditions: [
        { id: 1, name: '良品' },
        { id: 2, name: '不良品' },
        { id: 3, name: 'アウトレット' }
      ]
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    isValidAmount () {
      if (this.stock) {
        return Number(this.amount) > Number(this.stock.amount)
      } else return false
    }
  },
  mounted () {
    window.$(this.$refs.vuemodal).on('shown.bs.modal', this.setInitialData)
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    setInitialData () {
      this.from_warehouse_id = 0
      this.referenceAt = this.date
      this.timeReferenceAt = format(new Date(), 'HH:mm')
      let $this = this
      this.warehouses.forEach(function (v) {
        if (v.name === $this.stock.warehouse) {
          $this.from_warehouse_id = v.id
        }
      })
      this.to_conditions.forEach((c) => {
        if (c.id === $this.condition + 1) {
          $this.to_condition_id = c.id
        }
      })
      this.to_warehouse_id = 0
      this.amount = 0
      this.amount_max = $this.stock.amount // MAX
      this.in_stock_status = $this.stock.in_stock_status // 1:良品、0:不良品
      this.getNewQuantity()
    },

    async getNewQuantity () {
      this.isSearching = true
      try {
        const params = {
          condition: this.stock.in_stock_status,
          date: format(new Date(`${this.referenceAt} ${this.timeReferenceAt}`), "yyyy-MM-dd'T'HH:mm:59"),
          product_id: this.stock.product_id,
          warehouse_id: this.from_warehouse_id
        }
        const { data: { status, data } } = await this.$http.post(
          this.$api_url.inventory_quantity_single,
          params
        )

        if (status) {
          this.stock.amount = data
        } else {
          throw new Error('Something went wrong.')
        }
      } catch (error) {}
      this.isSearching = false
    },

    async moveWarehouse () {
      if (Number(this.amount) <= 0) {
        this.$toastr.warning('移動する数は整数で入力してください。')
        return
      }

      if (Number(this.amount) > Number(this.amount_max)) {
        this.$toastr.warning('在庫数量以下をご入力ください')
        return
      }

      if (this.to_condition_id === 0) {
        this.$toastr.warning('コンディションを選択してください')
        return
      }

      if (this.to_warehouse_id === 0) {
        this.$toastr.warning('移動先を選択してください')
        return
      }

      this.$dialog.confirm('在庫を移動しますか?').then(async () => {
        this.isSearching = true
        try {
          let params = {
            stock_id: this.stock.id,
            in_stock_status: this.stock.in_stock_status,
            amount: this.amount,
            warehouses_id_from: this.from_warehouse_id,
            warehouses_id_to: this.to_warehouse_id,
            is_own_return: Number(this.stock.bill_to_id) === 0,
            reference_at: format(new Date(`${this.referenceAt} ${this.timeReferenceAt}`), "yyyy-MM-dd'T'HH:mm:59"),
            condition: Number(this.to_condition_id) - 1
          }
          console.log('MoveInventory: ' + this.$api_url.inventory_move + ':params ', JSON.stringify(params))
          let moveInventory = await this.$http.post(this.$api_url.inventory_move, params)
          let $data = this.$invoiceTools.prepareResult(moveInventory.data, '', 'ArchiveInventories:moveInventory')
          console.log('MoveInventory: ' + this.$api_url.inventory_move + ':raw_response', JSON.stringify($data))
          if ($data.success === true) {
            this.$toastr.success('在庫移動に成功しました。', 'Success')
            const btn = this.$refs.closeModal
            this.$emit('reload-page', true)
            btn.click()
          } else {
            this.$toastr.error($data.data, 'エラー')
          }
          this.isSearching = false
        } catch (error) {
          this.isSearching = false
          console.log('ArchiveInventories:moveInventory:catch(error): ', JSON.stringify(error))
          this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        }
      })
    }
  }
}
</script>

<style scoped>
.input-date {
  width: 100%;
}

.input-amount {
  min-width: 30px;
}
</style>
